// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f80fe021","977":"0c2b5bd0"}[chunkId] + ".chunk.js";
};